import React, { useState } from 'react';
import { ToggleElement } from '../../schema/toggle.schema';
import styles from '../../assets/css/toggle.module.css';
import { Checkbox, FormControlLabel } from '@mui/material';
import { FormDataValue } from '../../hooks/useFormData';

interface ToggleComponentProps {
	element: ToggleElement;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

interface ToggleProps {
	label: string;
	isChecked: boolean;
	handleChange: () => void;
	required?: boolean;
}

const ToggleComponent: React.FC<ToggleComponentProps> = ({ element, onChange, onValidationChange }) => {
	const { key, label, selected, tags, required } = element;
	const [isChecked, setIsChecked] = useState(selected);
	const [valid, setIsValid] = useState(required ? selected : true);

	const handleChange = () => {
		setIsChecked((prevState) => !prevState);
		setIsValid(required ? isChecked : true);

		onChange(key, isChecked);
		onValidationChange(key, valid);
	};

	if (tags.includes('ACCEPT')) {
		return (
			<div className={styles['toggle-container']}>
				<AcceptToggle label={label} isChecked={isChecked} handleChange={handleChange} required={required} />
			</div>
		);
	}
	if (tags.includes('SETTINGS')) {
		return (
			<div className={styles['toggle-container']}>
				<SettingsToggle label={label} isChecked={isChecked} handleChange={handleChange} required={required} />
			</div>
		);
	}
	{
		return (
			<div className={styles['toggle-container']}>
				<DefaultToggle label={label} isChecked={isChecked} handleChange={handleChange} required={required} />
			</div>
		);
	}
};
const AcceptToggle: React.FC<ToggleProps> = ({ label, isChecked, handleChange, required }) => {
	return (
		<FormControlLabel
			control={<Checkbox checked={isChecked} onChange={handleChange} color="primary" required={required} />}
			label={label}
		/>
	);
};

const SettingsToggle: React.FC<ToggleProps> = ({ label, isChecked, handleChange, required }) => {
	const sliderStyle: React.CSSProperties = {
		backgroundColor: isChecked ? '#0082e1' : '#ccc',
		boxShadow: isChecked ? `0 0 1px #0082e1` : 'none'
	};

	return (
		<div className={styles['toggle-container']}>
			<label className={styles.switch}>
				<input type="checkbox" checked={isChecked} onChange={handleChange} required={required} />
				<span className={`${styles.slider} ${styles.round}`} style={sliderStyle}></span>
			</label>
			<label className={styles['label-container']}>{label}</label>
		</div>
	);
};

const DefaultToggle: React.FC<ToggleProps> = ({ label, isChecked, handleChange, required }) => {
	return (
		<FormControlLabel
			control={<Checkbox checked={isChecked} onChange={handleChange} color="primary" required={required} />}
			label={label}
		/>
	);
};

export default ToggleComponent;
